import React, { FC, useState } from 'react';
import styled, { css } from 'styled-components';
import check from './img/check.svg';

interface Props {
	size?: number;
	checked?: boolean;
	borderRadius?: number;
	borderColor?: string;
	checkedColor?: string;
	withoutState?: boolean;
	onClick?: (value: boolean) => void;
}

const StyledCheckbox = styled.div<Props>`
	width: ${({ size }) => size ?? 21}px;
	height: ${({ size }) => size ?? 21}px;
	border: 2px ${({ theme, borderColor }) => borderColor ?? theme.colors.border} solid;
	border-radius: ${({ borderRadius, theme }) => borderRadius ?? theme.borderRadius.sm ?? '5px'};
	${({ checked }) =>
		checked
			? css<Props>`
					border: none;
					background: url(${check}) no-repeat center center,
						${({ theme, checkedColor }) => checkedColor ?? theme.colors.primaryGradient4};
			  `
			: ''}
	&:hover {
		cursor: pointer;
	}
`;

export const Checkbox: FC<Props> = props => {
	const { checked = false, onClick, withoutState } = props;
	const [value, setValue] = useState(checked);

	const handleClick = (value: boolean): void => {
		onClick?.(!value);
		setValue(prev => !prev);
	};

	return (
		<StyledCheckbox
			{...props}
			checked={withoutState ? checked : value}
			onClick={() => {
				handleClick(value);
			}}
		/>
	);
};
